module.exports = __webpack_public_path__ + "img/Ilustraciones-Difarmer-1.66282405.jpg";